/** @jsx h */
import { h } from "hyperapp";
import nestable from "hyperapp-nestable";
import dragula from "dragula";

const initialState = {
  onDrag: () => ({}),
  dragger: null
};
const actions = {
  init: props => {
    const { onDrag } = props;
    if (onDrag) {
      return {
        onDrag
      };
    }
  },
  onCreate: el => state => {
    const { onDrag } = state;
    const containers = [el];
    const dragger = dragula(containers, {
      direction: "vertical",
      moves: (el, container, handle) => {
        return handle.dataset.dragHandle === "true";
      }
    });
    dragger.on("drop", () => {
      const indices = Array.prototype.slice.call(
        el.querySelectorAll("[data-index]")
      );
      onDrag(
        indices.map(element => window.parseInt(element.dataset.index, 10))
      );
    });
    return { dragger };
  },
  onDestroy: el => state => {
    state.dragger.destroy();
  }
};

const Sortable = nestable(
  initialState,
  actions,
  (state, actions) => (props, children) => {
    const { itemKeys } = props;
    return (
      <div oncreate={actions.onCreate} ondestroy={actions.onDestroy}>
        {children.map((child, index) => (
          <div key={`${itemKeys[index]}__${index}`} data-index={index}>
            {child}
          </div>
        ))}
      </div>
    );
  },
  "sortable-"
);

export default Sortable;
